import { JSX } from 'react';
import RobotC2 from './components/robotC2';

function App(): JSX.Element {
  return <RobotC2 />;
}

export default App;
